/* @flow */

import { route } from 'preact-router';
import { type AxiosPromise } from 'axios';
import ordenar from '../../utils/ordenar';
import * as duckCadastroEndereco from './cadastro-endereco';
import { type EnderecoEntrega } from '../../enderecos/types';
import { type GetState, type State } from '../../preact-app/types';
import { type StateGridEndereco } from './types';
import grid from '../../grid-preact';
import { getCliente } from './pedido';
import { selecionarEnderecoPorId } from './endereco';
import api from '../../utils/api';

export const getGridEndereco = (state: State) => state.balcao.gridEnderecos;

const getOrdenacao = state => getGridEndereco(state).ordenacao;

const {
    reducer: gridReducer,
    actions: {
        alterarOrdem,
        alterarItens,
        pesquisarSetAtalhos,
    },
} = grid({
    namespace: 'balcao/grid-endereco',
    getGrid: getGridEndereco,
    pesquisar: () => (
        dispatch: Function,
        getState: GetState,
    ): AxiosPromise<EnderecoEntrega[]> => {
        const cliente = getCliente(getState());
        const ordenacao = getOrdenacao(getState());

        if (!cliente) {
            route('/balcao', true);
            return Promise.reject();
        }

        return api.getEnderecoEntrega(cliente.id, {
            quantidade: 999,
        })
            .then(({ data: itens }) => dispatch(alterarItens([...itens.sort(ordenar(ordenacao))])));
    },
});

// Thunks

export {
    pesquisarSetAtalhos,
    alterarOrdem,
    selecionarEnderecoPorId,
};

export const cadastrar = (usuariosId: number) => (dispatch: Function) => {
    dispatch(duckCadastroEndereco.limpar());
    route(`/balcao/clientes/${usuariosId}/enderecos/novo`);
};

const initialState = {
    itens: [],
    ordenacao: 'logradouro ASC',
};

const gridEnderecosReducer = (
    state: StateGridEndereco = initialState,
    action: Object,
) => gridReducer(state, action);

export default gridEnderecosReducer;
